import { css, html, LitElement, PropertyValues, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { ZERO_COLUMN, ZERO_RECORD } from '../configure/zero-config.js'
import { ColumnConfig, GristRecord } from '../types.js'

@customElement('ox-card-gutter')
export class DataCardGutter extends LitElement {
  static styles = [
    css`
      :host {
        display: flex;
        background-color: transparent;
        align-content: center;
        align-items: center;
        text-overflow: ellipsis;
      }

      :host([row-selector]) {
        margin-right: auto;
      }

      * {
        border: 0;
        font-size: var(--md-sys-typescale-label-medium-size, 0.8rem);
        line-height: var(--md-sys-typescale-label-medium-size, 0.8rem);

        color: var(--md-sys-color-on-primary);
        background-color: var(--md-sys-color-primary);
        border-radius: var(--data-card-item-btn-border-radius, var(--md-sys-shape-corner-tiny));

        padding: var(--spacing-small);
      }

      /* button hover 효과는 button 자체에만 — *:hover 로 광범위 적용 시 자식
       * (span/md-icon) 의 individual hover 가 secondary background 작은 박스를
       * 그려서 부자연. 자식들은 button hover 의 효과를 상속받기만 한다. */
      button:hover {
        cursor: pointer;
        color: var(--md-sys-color-on-secondary);
        background-color: var(--md-sys-color-secondary);
      }

      :host([danger]) button {
        color: var(--md-sys-color-on-error);
        background-color: var(--md-sys-color-error);
        border-color: var(--md-sys-color-error);
      }

      :host([danger]) button:hover {
        color: var(--md-sys-color-error);
        background-color: var(--md-sys-color-on-secondary);
        border-color: var(--md-sys-color-on-secondary);
      }

      button {
        display: flex;
        gap: var(--spacing-small);
        border: 0;
        align-items: center;
      }

      /* 자식 (span / md-icon) 은 button 의 color 를 inherit — button hover / danger
       * 상태에서 color 가 변하면 자식 글자 / 아이콘 색도 함께 반전. 상위의 *{...}
       * 가 모든 자식에 color 박아서 inherit 안 되던 문제 보수. */
      button > * {
        color: inherit;
      }

      button md-icon {
        border: 0;
        padding: 0;
        background-color: unset;
      }

      button span {
        padding: 0;
        background-color: transparent;
      }
    `
  ]

  @property({ attribute: true }) align?: string
  @property({ type: Object }) record: GristRecord = ZERO_RECORD
  @property({ type: Object }) column: ColumnConfig = ZERO_COLUMN
  @property({ type: Number }) rowIndex: number = -1
  @property({ type: Object }) value?: object

  render(): TemplateResult {
    if (!this.column) {
      return html``
    }

    var { value, column, record, rowIndex } = this
    var { renderer } = column.record

    /* renderer가 html template이 아니고 단순한 값인 경우가 있으므로, html 템플릿으로 감싸준다. */
    return html` ${renderer(value, column, record, rowIndex, this)} `
  }

  updated(changes: PropertyValues<this>) {
    if (changes.has('column')) {
      const { gutterName, danger } = this.column

      if (gutterName == 'row-selector') {
        this.setAttribute('row-selector', '')
      } else {
        this.removeAttribute('row-selector')
      }

      if (danger) {
        this.setAttribute('danger', '')
      } else {
        this.removeAttribute('danger')
      }
    }
  }
}
